// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3KWom","clinicsSelect":"TableHeading_clinicsSelect__1xddr"};